import { NgModule } from '@angular/core';
import { NavigationError, PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { TokenGuard } from './core/guards/token.guard';
import { notFoundRoute } from './core/config/routes.config';

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [TokenGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
  constructor(router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationError && !event.url.includes(notFoundRoute)) {
        router.navigateByUrl(notFoundRoute);
      }
    });
  }
}
